<template>
  <a-layout class='index animated fadeIn'>
    <a-spin :spinning='spinning'>
      <a-card :bordered='false'>
        <a-row type="flex" justify="space-between">
          <a-col class="s_flex_ali" :span="12">
            <img class="width-93 height-93 m-l-60" :src="authorizeData.basicInfo.head_img" alt="" />
            <div class="m-l-20">
              <p class="fz-22 m-b-10 s_font_b s_c333">{{authorizeData.basicInfo.nick_name}}</p>
              <p class="fz-16 s_c999">原始ID：{{authorizeData.basicInfo.user_name}}</p>
            </div>
          </a-col>
          <a-col :span="3">
            <img class="width-130 height-130" :src="qrcode_url" alt="" />
          </a-col>
        </a-row>
        <a-form class="m-t-20" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item label="微信账号类型">
            <p class="s_c333">{{authorizeData.basicInfo.service_type_info}}</p>
          </a-form-item>
          <a-form-item label="微信AppID" help='(绑定成功之后，出现微信AppID则绑定成功！)'>
            <a-input v-model:value="authorizeData.sysInfo.app_id" placeholder='请输入' readonly />
          </a-form-item>
          <a-form-item label="微信关注URL">
            <a-input v-model:value="followUrl" placeholder='请输入' />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" v-has:wechatBindSet="editAuthorize">
              提交
            </a-button>
          </a-form-item>
          <a-divider />
          <a-form-item :label="'已授权给'+authorizeData.basicInfo.nick_name+'的权限'" :label-col="{span:6}">
            <ul class="p-l-25">
              <li class="s_c333" style="list-style-type:disc" v-for='item in authorizeData.authorization_info' :key='item'>{{item}}</li>
            </ul>
          </a-form-item>
        </a-form>
      </a-card>
    </a-spin>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message, Modal } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getWx_authorize, setWx_authorize, editWx_authorize } from '@/api/public_wx';
  import store from '@/store'
  export default {
    setup(props) {
      const state = reactive({
        qrcode_url:'',
        spinning:true,
        followUrl:'',
        authorizeData: {
          basicInfo:{},
          sysInfo:{},
        },
           info: store.state.user.info,
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      })

      const $getUrlKey = inject("$getUrlKey");
      const getAuthorize = async () => {
        state.spinning = true
        let res = await getWx_authorize().then(res => res.data);
        if (iscode(res)) {
          if (res.data.is_auth == 0) {
             Modal.confirm({
                centered: true,
                content: "当前账号未绑定微信,是否跳转绑定",
                onOk: async () => {
                  window.location.href = res.data.authorizationUrl
                },
              });
          } else {
            state.authorizeData = res.data
            state.qrcode_url = state.info.picdomain+res.data.basicInfo.qrcode_url
            state.followUrl = res.data.sysInfo.follow_url
          }
          state.spinning = false
        } else {
          message.error(res.msg);
        }
      }
      const setAuthorize = async (auth_code) => {
        let res = await setWx_authorize({ auth_code: auth_code }).then(res => res.data);
        if (iscode(res)) {
          getAuthorize();
        } else {
          message.error(res.msg);
        }
      }
      const editAuthorize = async () =>{
        // if (state.followUrl == '') {
        //   message.error('微信关注URL不能为空');
        //   return false
        // } 
        let res = await editWx_authorize({ follow_url: state.followUrl }).then(res => res.data);
        if (iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
      }
      onMounted(() => {
        var auth_code = $getUrlKey.getUrlKey('auth_code')
        if (auth_code == null) {
          getAuthorize();
        } else {
          setAuthorize(auth_code);
        }
      });
      return {
        ...toRefs(state),
        editAuthorize
      };
    },
  };
</script>